module.exports = "<div class=\"container d-flex align-items-center justify-content-center m-auto\">\n  <i class=\"svg-container mr-2\" inlineSVG=\"/assets/images/icon.svg\"></i>\n  <div>\n    <h1>\n      В настоящий момент наш сайт находится в разработке. В скором времени мы запустим онлайн платформу для ветеранов боевых действий\n    </h1>\n    <p>По всем вопросам вы можете связаться с нами через контакты на сайте:</p>\n    <a href=\"https://pamyatpokoleniy.ru/\">pamyatpokoleniy.ru</a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/empty-site/empty-site.component.html
// module id = ./src/app/core/empty-site/empty-site.component.html
// module chunks = main